import { mainApi } from '@/lib/api';
import { Section, SectionContentData, SectionType } from '@/types/store';
import { AxiosResponse } from 'axios';
import type { SectionOrderItem } from '../types/store';

export async function updateSectionsOrder(storeId: number, sections: SectionOrderItem[]): Promise<AxiosResponse> {
    return await mainApi.patch(`v1/stores/${storeId}/sections/order`, sections);
}

export async function updateSection(
    storeId: number,
    sectionId: number,
    data: SectionContentData & { type: SectionType }
): Promise<AxiosResponse> {
    return await mainApi.post(`v1/stores/section/${storeId}`, {
        section_id: sectionId,
        ...data,
    });
}

export async function deleteSection(storeId: number, sectionId: number): Promise<AxiosResponse> {
    return await mainApi.patch(`v1/stores/${storeId}/sections`, {
        section_id: sectionId,
        status: 0,
    });
}

export async function createSection(
    storeId: number,
    data: SectionContentData & { type: SectionType }
): Promise<AxiosResponse<{ section: Section }>> {
    return await mainApi.post(`v1/stores/section/${storeId}`, data);
}
